import { Container, Row, Col } from "react-bootstrap";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import html from '../assets/img/html.svg'
import css from '../assets/img/css.svg'
import javascript from '../assets/img/javascript.svg'
import java from '../assets/img/java.svg'
import react from '../assets/img/react.svg'
import python from '../assets/img/python.svg'
import git from '../assets/img/git.svg'
import nodejs from '../assets/img/nodejs.svg'


export const Skills = () => {
    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 5
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 5
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 2
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1
        }
      };

    return (
        <section className="skill" id="skills">
          <Container>
            <Row>
                <Col>
                  <div className="skill-bx">
                    <h2>
                        Skills
                    </h2>
                    <p>Here is a list of Tech Stacks that I have dabbled with!</p>
                    <Carousel responsive={responsive} infinite={true} className="skill-slider">
                        <div className="item">
                            <img src={html} alt="Image" />
                            <h5>HTML</h5>
                        </div>
                        <div className="item">
                            <img src={css} alt="Image" />
                            <h5>CSS</h5>
                        </div>
                        <div className="item">
                            <img src={javascript} alt="Image" />
                            <h5>Javascript</h5>
                        </div>
                        <div className="item">
                            <img src={java} alt="Image" />
                            <h5>Java</h5>
                        </div>
                        <div className="item">
                            <img src={python} alt="Image" />
                            <h5>Python</h5>
                        </div>
                        <div className="item">
                            <img src={react} alt="Image" />
                            <h5>React</h5>
                        </div>
                        <div className="item">
                            <img src={git} alt="Image" />
                            <h5>Git</h5>
                        </div>
                        <div className="item">
                            <img src={nodejs} alt="Image" />
                            <h5>Nodejs</h5>
                        </div>
                    </Carousel>
                  </div>
                </Col>
            </Row>
          </Container>
        </section>

    )
}